export default __webpack_public_path__ + "b41ad8aff02bbb50038a92cd689f30c3.png";